import { render, staticRenderFns } from "./host-product-home.vue?vue&type=template&id=627762a0&scoped=true&"
import script from "./host-product-home.vue?vue&type=script&lang=js&"
export * from "./host-product-home.vue?vue&type=script&lang=js&"
import style0 from "./host-product-home.vue?vue&type=style&index=0&id=627762a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627762a0",
  null
  
)

export default component.exports